import React, { useEffect } from "react";
import { createStyles, makeStyles, Breadcrumbs, Link } from "@material-ui/core";
import { observer, useLocalStore } from "mobx-react-lite";
import { autorun } from "mobx";
import { Copyright } from "../../core/Copyright";
import Navbar from "./Components/Navbar";
import Menu from "./Components/Menu";
import { useStores } from "../../_stores";
// import { firstLinks } from "../../core/Links";

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            position: 'relative',
            height: '100%',
            width: '100%',
            zIndex: 1201,
            top: 0,
            left: 0,
        }, 
        container: {
            position: 'absolute',
            top: '117px',
            left: 0,
            right: 0,
            bottom: '22px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
        },
    })
);

type LayoutProps = {
    children: any;
    offset?: {
        left?: number;
        right?: number;
        top?: number;
        bottom?: number;
    };
}

export const Layout = observer((props: LayoutProps) => {
    const classes = useStyles();
    const {children, offset} = props;
    const { linksStore, socketStore} = useStores();

    const state = useLocalStore(() => ({
        sidebarIsOpen: false,
    }));

    const openSidebar = () => state.sidebarIsOpen = true;
    const closeSidebar = () => state.sidebarIsOpen = false;

    useEffect(() => {
        autorun(async () => {
            if(!socketStore.isConnected)
                await socketStore.open("", "install,update,delete:ru");
        });
        return () => socketStore.close();
    }, [socketStore]);
    
    return (
        <div>
            <div className={classes.root}>
                <Navbar
                    openSidebar={openSidebar}
                />
            </div>
            <Menu
                isOpen={state.sidebarIsOpen}
                close={closeSidebar}
                elems={linksStore.getLinks}
            />
            <div className={classes.container}>
                {children}
            </div>
            <Copyright/>
        </div>
    )
});